module.exports = __webpack_public_path__ + "img/visual2.be2634a4.png";